import BreadcrumbsWrapper from "../../components/breadcrumbs/BreadcrumbsWrapper";
import React from "react";
import {Container, DownloadButton, DownloadIcon, HeaderWrapper} from "./Kpi.css";
import {Icon, theme} from "@elcimai/webankdesignsystem";

function Kpi(){
    return(
        <div className={Container}>
            <BreadcrumbsWrapper/>
            <div className={HeaderWrapper}>
                <h1>KPI</h1>
            </div>
            <a className={DownloadButton} href="kpi/kpi_t4.pdf" target="_blank" download>
                <Icon size={20} icon={"Doc"} color={theme.colours.brand.colorg11}></Icon> 4ème trimestre <span className={DownloadIcon}><Icon size={18} icon={"Telechargement"} color={theme.colours.brand.colorg11}></Icon></span>
            </a>
            <a className={DownloadButton} href="kpi/kpi_t3.pdf" target="_blank" download>
                <Icon size={20} icon={"Doc"} color={theme.colours.brand.colorg11}></Icon> 3ème trimestre <span className={DownloadIcon}><Icon size={18} icon={"Telechargement"} color={theme.colours.brand.colorg11}></Icon></span>
            </a>
            <a className={DownloadButton} href="kpi/kpi_t2.pdf" target="_blank" download>
                <Icon size={20} icon={"Doc"} color={theme.colours.brand.colorg11}></Icon> 2ème trimestre <span className={DownloadIcon}><Icon size={18} icon={"Telechargement"} color={theme.colours.brand.colorg11}></Icon></span>
            </a>
            <a className={DownloadButton} href="kpi/kpi_t1.pdf" target="_blank" download>
                <Icon size={20} icon={"Doc"} color={theme.colours.brand.colorg11}></Icon> 1er trimestre <span
                className={DownloadIcon}><Icon size={18} icon={"Telechargement"} color={theme.colours.brand.colorg11}></Icon></span>
            </a>
        </div>
    )
}

export default Kpi;